import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
  Platform,
} from '@ionic/angular';
import { App } from 'ionic';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppInfo } from 'src/data/app-info';
import { DeviceInfo } from 'src/data/device-info';
import { PlayerInfo } from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { DeviceService } from 'src/providers/device-service/device-service';
import { ImageService } from 'src/providers/image-service/image-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeActions } from 'src/redux/player-home';
import { SessionDataService } from 'src/redux/session';
import { ContentType } from 'src/remote-request';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';
@Component({
  selector: 'app-profile-image-edit',
  templateUrl: './profile-image-edit.component.html',
  styleUrls: ['./profile-image-edit.component.scss'],
})
export class ProfileImageEditComponent implements OnInit {
  player$: Observable<PlayerInfo>;
  playerPhoto$: Observable<string>;
  friend: boolean;
  deviceInfo: DeviceInfo = {
    deviceId: 'unknown',
    virtual: true,
  };
  appInfo: AppInfo = {};
  constructor(
    private playerHomeActions: PlayerHomeActions,
    private loadingCtl: LoadingController,
    private alertCtl: AlertController,
    private modalCtl: ModalController,
    private imageService: ImageService,
    private playerService: PlayerService,
    private platform: Platform,
    private actRoute: ActivatedRoute,
    private navParams: NavParams,
    private sessionService: SessionDataService,
    private deviceService: DeviceService,
    private flightService: ClubFlightService
  ) {
    this.friend = navParams.get('friend');
    this.player$ = navParams.get('player');
    this.playerPhoto$ = this.player$.pipe(
      map((playerInfo: PlayerInfo) => {
        if (playerInfo.photoUrl) {
          return playerInfo.photoUrl;
        } else if (!playerInfo.photoUrl && playerInfo.thumbnail) {
          return playerInfo.thumbnail;
        } else {
          return '';
        }
      })
    );
  }

  ngOnInit() {
    this.deviceService.getDeviceInfo().then((deviceInfo: DeviceInfo) => {
      this.deviceInfo = deviceInfo;
      console.debug('device info : ');
      console.debug(this.deviceInfo.platformVersion);
      console.debug(this.deviceInfo.platform);
    });
    this.deviceService.getAppInfo().then((appInfo: AppInfo) => {
      this.appInfo = appInfo;
      console.debug('app info : ');
      console.debug(this.appInfo.versionCode);
      console.debug(this.appInfo.versionNumber);
    });
  }
  takePhoto() {
    (this.imageService.captureImage(true).then((data: any) => {
      this._uploadImage(data.dataUrl);
    }),
      error => {
        // alert(JSON.stringify(error));
      });
  }
  isCapacitor() {
    return this.platform.is('capacitor');
  }
  selectPhoto() {
    (this.imageService.pickImage().then((data: any) => {
      this._uploadImage(data.dataUrl);
    }),
      error => {
        //Ignore this error
      });
  }
  private getPlayerId() {
    return this.player$.pipe(take(1)).pipe(map((player: PlayerInfo) => player.playerId));
  }
  globalFormData = new FormData();
  _uploadImage(imageURL: string) {
    this.getPlayerId().subscribe(async (playerId: number) => {
      let uploadLoading = await this.loadingCtl.create({
        message: 'Uploading, Please wait...',
      });
      let _authToken;
      this.sessionService.getAuthToken().subscribe(data => {
        _authToken = data;
      });
      if (!this.isCapacitor() || this.getAndroidVersion() >= 10) {
        console.debug('');
        uploadLoading.present().then(() => {
          // ContentType.JPEG
          this.flightService
            .updatePlayerPhotoWeb(
              this.selectedFiles,
              imageURL,
              ContentType.WILDCARD_IMAGE,
              playerId,
              _authToken,
              this.globalFormData
            )
            // this.playerHomeActions.addPlayerType(imageURL, ContentType.WILDCARD_IMAGE, this.player.playerId, this.selectedPlayerType.id)
            .subscribe(
              data => {
                uploadLoading.dismiss().then(() => {
                  // if(data) this.playerDiscountProgram = data;
                  if (data) this.temporaryImageURL = imageURL;
                  this.cancelEditImage();
                });
              },
              error => {
                console.log('[photo] uploading image : ', error);
                uploadLoading.dismiss().then(async () => {
                  // let _error = error.error;
                  // if(error.json()) _error = error.json();
                  // else _error = error.error;
                  let _msg = 'Please upload photo not more than 10 MB';
                  // if(_error && _error.errorMessage) _msg = _error.errorMessage;
                  // 'Please upload photo not more than 10 MB'
                  // if(error || error !== null) {
                  let alert = await this.alertCtl.create({
                    header: 'Upload Error',
                    message: _msg,
                    buttons: ['Ok'],
                  });
                  alert.present();
                  // }
                  // else this.cancelEditImage();
                });
              },
              () => {
                // this.viewCtrl.dismiss({
                //     created: true
                // });
              }
            );
        });
      } else {
        uploadLoading.present().then(() => {
          (this.playerHomeActions
            .updatePlayerPhoto(imageURL, ContentType.WILDCARD_IMAGE, playerId, this.friend)
            .subscribe((player: PlayerInfo) => {
              uploadLoading.dismiss().then(() => {
                this.cancelEditImage();
              });
            }),
            error => {
              uploadLoading.dismiss().then(async () => {
                // 'Please upload photo not more than 10 MB'
                let alert = await this.alertCtl.create({
                  header: 'Upload Error',
                  message: 'Please upload photo not more than 10 MB',
                  buttons: ['Ok'],
                });
                alert.present();
              });
            });
        });
      }
    });
  }
  cancelEditImage() {
    this.modalCtl.dismiss({
      needRefresh: true,
    });
  }
  close() {
    this.modalCtl.dismiss({
      needRefresh: false,
    });
  }

  selectedFiles: any = [];
  previewImage: Array<any>;
  temporaryImageURL: string;
  async changePhoto(event, mode?: string) {
    // if (event) {
    //   const fileObject = event.target.files[0];
    // }

    this.selectedFiles = event.target.files[0];
    // const file = (event.target as HTMLInputElement).files;
    // console.log('file -->',file);

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      const images = [];
      for (let i = 0; i < filesAmount; i++) {
        const reader = new FileReader();
        // eslint-disable-next-line @typescript-eslint/no-shadow
        reader.onload = (event: any) => {
          // Push Base64 string
          images.push(event.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
        console.debug('take photo : ', event);
        console.debug('take photo : ', reader);
        console.debug('take photo : ', reader.result);
        // console.debug('take photo : ', reader.readAsDataURL(event.target.files[i]))
      }
      this.temporaryImageURL = event.target.files[0].name;
      console.debug('take photo : ', this.selectedFiles);
      console.debug('take photo : ', this.temporaryImageURL);
      this.previewImage = images;
      if (this.selectedFiles && mode === 'update') this._uploadImage(this.temporaryImageURL);
    }
  }

  getAndroidVersion() {
    if (!this.platform.is('cordova')) return;
    if (this.platform.is('cordova') && this.platform.is('ios')) return 12;
    if (this.deviceInfo) return Number(this.deviceInfo.platformVersion);
  }

  async captureImage() {
    // const image = await Camera.getPhoto({
    //   quality: 90,
    //   allowEditing: false,
    //   // resultType: CameraResultType.Base64,
    //   resultType: CameraResultType.DataUrl,
    //   source: CameraSource.Camera
    // });
    this.imageService.captureImage(true).then(image => {
      const imageBlob = this.imageService.dataURLtoBlob(image.dataUrl);
      this.selectedFiles = imageBlob;
      this.temporaryImageURL = image.dataUrl;
      this._uploadImage(this.temporaryImageURL);
    });
  }

  async pickImage() {
    // const image = await Camera.getPhoto({
    //   quality: 90,
    //   allowEditing: false,
    //   // resultType: CameraResultType.Base64,
    //   resultType: CameraResultType.DataUrl,
    //   source: CameraSource.Camera
    // });
    this.imageService.pickImage().then(image => {
      const imageBlob = this.imageService.dataURLtoBlob(image.dataUrl);
      this.selectedFiles = imageBlob;
      this.temporaryImageURL = image.dataUrl;
      this._uploadImage(this.temporaryImageURL);
    });
  }

  // dataURLtoBlob(dataUrl: string): Blob {
  //   const byteString = atob(dataUrl.split(',')[1]);
  //   const mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0];

  //   const ab = new ArrayBuffer(byteString.length);
  //   const ia = new Uint8Array(ab);
  //   for (let i = 0; i < byteString.length; i++) {
  //     ia[i] = byteString.charCodeAt(i);
  //   }

  //   return new Blob([ab], { type: mimeString });
  // }

  // private base64ToBlob(base64: string, mimeType: string): Blob {
  //   const byteCharacters = atob(base64);
  //   const byteArrays = [];
  //   for (let offset = 0; offset < byteCharacters.length; offset += 512) {
  //     const slice = byteCharacters.slice(offset, offset + 512);
  //     const byteNumbers = new Array(slice.length);
  //     for (let i = 0; i < slice.length; i++) {
  //       byteNumbers[i] = slice.charCodeAt(i);
  //     }
  //     const byteArray = new Uint8Array(byteNumbers);
  //     byteArrays.push(byteArray);
  //   }
  //   return new Blob(byteArrays, { type: mimeType });
  // }

  async onClickUpdateImage() {
    let _dataList = [
      {
        id: 'captureImage',
        name: 'Take Photo',
        // iconUrl: 'assets/icons/golf-website.png',
      },
      {
        id: 'pickImage',
        name: 'Choose Photo',
        // iconUrl: 'assets/icons/book.png',
      },
    ];
    const modal = await this.modalCtl.create({
      mode: 'ios',
      component: CommonPullupMenuComponent,
      cssClass: 'self-adjustable-modal',
      componentProps: {
        app: null,
        dataList: _dataList,
        mode: 'common',
        headerTitle: 'Update Profile Image',
      },
    });
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug('pullup dismiss', data);
      if (data) {
        if (data?.data?.id === 'captureImage') {
          this.captureImage();
        } else if (data?.data?.id === 'pickImage') {
          this.pickImage();
        }
      }
    });
  }
}
